/**
 * Кто из игроков только что купил политику — по разнице двух снимков списка
 * игроков. Покупка видна по появлению нового nextPolicy: именно его выставляет
 * редьюсер BUY_POLICY (сама политика начинает действовать со следующего
 * раунда, поэтому у купившего меняется nextPolicy, а не только policy).
 *
 * Витрина главного меню читает игру только по состоянию: экшены до нее не
 * доходят (их проигрывает ReplayRunner/BotRunner внутри себя), а сравнение
 * снимков работает одинаково для записи матча и для живой партии ботов.
 *
 * @param {Array} prevPlayers - список игроков до обновления
 * @param {Array} nextPlayers - список игроков после
 * @returns {{playerId: string, policy: Object} | null}
 */
export const findPolicyPurchase = (prevPlayers, nextPlayers) => {
  if (!prevPlayers || !nextPlayers) return null;

  const buyers = nextPlayers.filter((player) => {
    const before = prevPlayers.find((prevPlayer) => prevPlayer.id === player.id);
    if (!before) return false;
    const nextPolicyId = player.nextPolicy?.id;
    return Boolean(nextPolicyId) && nextPolicyId !== before.nextPolicy?.id;
  });

  // Ровно один покупатель — это покупка. Изменение сразу у нескольких игроков
  // означает, что состояние пришло целиком (LOAD_STATE при старте записи или
  // ресинке), и рассказывать о «покупках» задним числом незачем
  if (buyers.length !== 1) return null;

  const buyer = buyers[0];
  return {playerId: buyer.id, policy: buyer.nextPolicy};
};
